import { render, staticRenderFns } from "./language-form.vue?vue&type=template&id=3cd04a6e&"
import script from "./language-form.vue?vue&type=script&lang=js&"
export * from "./language-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports